<template>
  <!-- Modal -->
  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="notificationEmailModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" style="margin-top: 10%" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-join">Pagamento no Cartão de Crédito</h5>

          <button
            type="button"
            class="close"
            id="closeReportsModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style="font-size: 1.5rem">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row row-mobile">
            <div class="col-md-12">
              <br />
              <h6 style="text-align: center">
                Ao efetuar o pagamento, será enviado um e-mail aprovando ou não a transação no cartão.
                <hr>
                Se e-mail abaixo estiver em branco, favor preencher.
              </h6>

            </div>
            <form class="col-md-12" autocomplete="off" @submit.prevent="updateNotificationEmail">
              <div class="col-md-12" style="padding: 0px 25px;">
                <div class="row form-group">
                  <div class="col-md-12">
                    <label class="form-check-label" for="notificationEmail">
                      Email:
                    </label>
                    <input
                      class="form-control"
                      type="email"
                      id="notificationEmail"
                      placeholder="Email"
                      v-model="email_notificacao"
                      v-bind:disabled="!edit_email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 access-center">
                <button
                  class="btn btn-lg access"
                  type="submit"
                  id="downloadReports"
                  v-bind:disabled="processing"
                >
                  Avançar
                </button>
                <br />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "NotificationEmailModal",
  data() {
    return {
      processing: false,
      email_notificacao: this.bill.email_notificacao,
      edit_email: !this.bill.email_notificacao
    };
  },

  props: ["bill"],

  mounted() {
    $("#notificationEmailModal").modal("show");
  },

  methods: {
    updateNotificationEmail: function () {
      let params = {
        boleto_id: this.bill.cod_id,
        email: this.email_notificacao,
      };

      this.processing = true;

      if (!this.edit_email) return this.openCheckoutLink()

      axios
        .put(`${process.env.API_PBM}/boletos/notificationEmail`, params)
        .then((response) => {
          this.processing = false;
          this.openCheckoutLink()
        })
        .catch((error) => {
          this.processing = false;
          Vue.$toast.error("Ops! Não foi possível completar a ação.", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
    openCheckoutLink: function () {
      $("#notificationEmailModal").modal('hide');
      window.open(this.bill.pagamento_parcelado.link, '_blank');
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-indent {
  justify-content: center;
  margin-left: 25px;
  margin-bottom: 30px;
}
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 15%;
}
.col-style {
  display: flex;
  justify-content: space-around;
  text-align: initial;
  font-size: 14px;
}

.modal-body {
  color: rgb(100, 95, 95);
}
.btn-style {
  border: none;
  background-color: #ffffff;
  cursor: pointer;
  color: rgb(100, 95, 95);
  font-size: 15px;
}

.icons {
  font-size: 17px;
  color: rgb(100, 95, 95);
  margin: 5px;
}

span {
  font-size: 16px;
}
.access {
  color: #fff;
  margin-top: 60px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  width: 25%;
}
.access-center {
  text-align: center;
  display: flex;
  justify-content: center;
}
.close {
  font-size: 1.5rem !important;
}
@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 5% !important;
    text-align: center;
  }

  .access-center {
    text-align: center;
    display: flex;
    margin-top: -60px;
    justify-content: center;
  }

  .col-md-4 {
    margin-top: 20px;
  }

  .modal-dialog {
    margin-top: 55% !important;
  }
}

@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
}
</style>



// WEBPACK FOOTER //
// src/views/components/home/bill/NotificationEmailModal.vue